import classNames from "classnames";
import { invariant } from "@searchui-searchforms/shared/utils";
import { getEventModelName } from "@/entities/data-model";
import type { EventFieldset } from "@/entities/form-metadata";
import { useIsNewEventEnabled } from "../useIsNewEventEnabled";
import styles from "./AddNewEventButton.module.scss";

interface AddNewEventButtonProps {
    fieldset: EventFieldset;
    onItemAdded: (fieldset: EventFieldset) => void;
}

export const AddNewEventButton = ({ fieldset, onItemAdded }: AddNewEventButtonProps) => {
    const isDisabled = useIsNewEventEnabled({ fieldset });

    const eventName = getEventModelName(fieldset);
    invariant(eventName, "eventName - must be defined");

    return (
        <button
            type="button"
            className={classNames(styles.addEvent, "link headerLink")}
            data-testid={`add-event-${fieldset.relation}-${fieldset.eventType}`}
            disabled={isDisabled}
            onClick={() => onItemAdded(fieldset)}
        >
            {fieldset.label}
        </button>
    );
};
